import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles(theme => ({
    marker: {
        cursor: "pointer",
        width: "1.8rem",
        height: "1.8rem",
        transform: "translate(-50%, -100%)",
        "& img": {
            width: "1.8rem",
            height: "1.8rem",
        },
    },
    tooltip: {
        opacity: 0.9,
        "& .MuiTooltip-tooltip": {
            fontSize: 10,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
        },
    },
}));
